import type { VoidFunctionComponent } from 'react';

import Select from '../../generic/Select/Select';
import type { SelectOption } from '../../../types';
import type { Fetcher } from '../../../../shared/fetchers';
import type { AnyFilter } from '../../../../shared/organizationPackages';

type Props = {
  isLoading: boolean;
  fetcherOptions: Array<SelectOption<Fetcher>>;
  selectedFetchers: Array<SelectOption<Fetcher>>;
  setFilters: (...args: AnyFilter[]) => void;
};

/**
 * Displays a multi-select dropdown for filtering packages by package managers (aka fetchers).
 */
const PackageManagerFilter: VoidFunctionComponent<Props> = ({
  isLoading,
  fetcherOptions,
  selectedFetchers,
  setFilters,
}) => {
  return (
    <div data-test-id="package-inventory-filters--fetchers">
      <Select
        isMulti
        isClearable
        id="Package manager"
        placeholder={isLoading ? 'Loading...' : 'Package manager'}
        value={selectedFetchers}
        options={fetcherOptions}
        isDisabled={isLoading}
        onChange={(fetchers) => {
          setFilters({ fetchers: (fetchers as Array<SelectOption<Fetcher>>).map(({ value }) => value) });
        }}
      />
    </div>
  );
};

export default PackageManagerFilter;
